import React from 'react';
import PropTypes from 'prop-types';

/**
 * All connectors in one SVG layer beneath the cards.
 *
 * Each edge is an orthogonal elbow: down out of the parent, across to the
 * child's column at a rail halfway down the vertical gap, then down into the
 * child. Every sibling shares that rail height, which is what makes the fan-out
 * under a manager read as one group instead of a tangle of diagonals.
 */
const OrgChartEdges = ({ edges, width, height }) => (
  <svg
    width={width}
    height={height}
    className="tw-absolute tw-top-0 tw-left-0 tw-pointer-events-none"
    aria-hidden="true"
  >
    {edges.map((edge) => (
      <path
        key={edge.id}
        d={`M ${edge.parentX} ${edge.parentY} V ${edge.railY} H ${edge.childX} V ${edge.childY}`}
        fill="none"
        stroke={edge.dimmed ? '#e2e8f0' : '#cbd5e1'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    ))}
  </svg>
);

OrgChartEdges.propTypes = {
  edges: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      parentX: PropTypes.number,
      parentY: PropTypes.number,
      childX: PropTypes.number,
      childY: PropTypes.number,
      railY: PropTypes.number,
      dimmed: PropTypes.bool,
    }),
  ).isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
};

export default React.memo(OrgChartEdges);
